var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"card",on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default"),(_vm.href)?[(_vm.externalLink)?_c('a',{staticClass:"card__link",attrs:{"href":_vm.href,"target":"_blank"}}):_c('router-link',{staticClass:"card__link",attrs:{"to":_vm.href}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }